import { lazy } from 'react'
import { owlAddJsError } from '@RootCommon/utils/owl'
import { logan } from '@RootCommon/utils/logan'
import { CUSTOM_METRICS as BusinessStatusCustomMetrics } from '../pages/BusinessStatus/constant'
import { CUSTOM_METRICS as ShopEvaluateCustomMetrics } from '../pages/EvaluateV2/constant'
import { CUSTOM_METRICS as ShopSettingCustomMetrics } from '../pages/Settings/constant'
import { CUSTOM_METRICS as BindQrcodeCustomMetrics } from '../pages/BindQrcode/constant'
import { CUSTOM_METRICS as ShopSettingsCustomMetrics } from '../pages/ShopSettings/constant'
import { CUSTOM_METRICS as NoAuthCustomMetrics } from '../pages/NoAuth/constant'

export default [
  {
    path: '*',
    label: '更多导航Default',
    component: lazy(() => import(/* webpackChunkName: "more-default" */ '@/pages/More')),
  },
  {
    path: '/more',
    label: '更多导航',
    component: lazy(() => import(/* webpackChunkName: "more" */ '@/pages/More')),
  },
  {
    path: '/shopSettings',
    label: '门店信息首页',
    component: lazy(() => import(/* webpackChunkName: "shop-settings" */ '@/pages/ShopSettings')),
    owlMetaKeys: {
      CRASH: ShopSettingsCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/settings',
    label: '营业时间设置首页',
    component: lazy(() => import(/* webpackChunkName: "settings" */ '@/pages/Settings')),
    owlMetaKeys: {
      CRASH: ShopSettingCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/settings/editNormal',
    label: '营业时间设置',
    component: lazy(() => import(/* webpackChunkName: "edit-normal" */ '@/pages/Settings/Edit_Normal')),
    owlMetaKeys: {
      CRASH: ShopSettingCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/settings/editSpecial',
    label: '特殊时间编辑',
    component: lazy(() => import(/* webpackChunkName: "edit-special" */ '@/pages/Settings/Edit_Special')),
    owlMetaKeys: {
      CRASH: ShopSettingCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/shopSettings/editPhone',
    label: '电话编辑',
    component: lazy(() => import(/* webpackChunkName: "edit-phone" */ '@/pages/ShopSettings/PhoneEdit')),
  },
  {
    path: '/shopSettings/editDelivery',
    label: '配送信息编辑',
    component: lazy(() => import(/* webpackChunkName: "edit-delivery" */ '@/pages/ShopSettings/DeliveryEdit')),
  },
  {
    path: '/shopSettings/mapDetail',
    label: '地图查看页',
    component: lazy(() => import(/* webpackChunkName: "map-detail" */ '@/components/MapDetail')),
  },
  {
    path: '/businessStatus',
    label: '营业状态',
    component: lazy(() => import(/* webpackChunkName: "business-status" */ '@/pages/BusinessStatus')),
    owlMetaKeys: {
      // PV: '',
      CRASH: BusinessStatusCustomMetrics.B_APP_BUSINESS_STATUS_CRASH_NUM.KEY,
    },
  },
  {
    path: '/accountRelease/apply',
    label: '账号注销申请',
    component: lazy(() => import(/* webpackChunkName: "account-release" */ '@/pages/AccountRelease')),
  },
  {
    path: '/privacyAgreement',
    label: '查看隐私协议',
    component: lazy(() => import(/* webpackChunkName: "privacy-agreement" */ '@/pages/PrivacyAgreement')),
  },
  // 已迁移machpro-PC复用，可移除
  {
    path: '/award',
    label: '店铺健康度',
    component: lazy(() => import(/* webpackChunkName: "award" */ '@/pages/Award')),
    owlMetaKeys: {
      CRASH: 'B_APP_AWARD_CRASH',
    },
    onError (error) {
      owlAddJsError('【H5店铺分】页面crash', { error })
      logan({ actionKey: '【H5店铺分】页面crash', params: { error } })
    },
  },
  {
    path: '/evaluate',
    label: '顾客评价',
    component: lazy(() => import(/* webpackChunkName: "evaluate" */ '@/pages/EvaluateV2')),
    owlMetaKeys: {
      CRASH: ShopEvaluateCustomMetrics.B_APP_SHOP_EVALUATE_CRASH_NUM.KEY,
    },
  },
  {
    path: '/evaluate/appealList',
    label: '顾客评价申诉列表',
    component: lazy(() => import(/* webpackChunkName: "evaluate-appealList" */ '@/pages/EvaluateV2/components/EvaluateAppealList')),
    owlMetaKeys: {
      CRASH: ShopEvaluateCustomMetrics.B_APP_SHOP_EVALUATE_CRASH_NUM.KEY,
    },
  },
  {
    path: '/evaluate/appealDetail',
    label: '顾客评价申诉详情',
    component: lazy(() => import(/* webpackChunkName: "evaluate-appealDetail" */ '@/pages/Evaluate/components/EvaluateAppealDetail/routerPage')),
    owlMetaKeys: {
      CRASH: ShopEvaluateCustomMetrics.B_APP_SHOP_EVALUATE_CRASH_NUM.KEY,
    },
  },
  {
    path: '/evaluate/appealSubmit',
    label: '顾客评价申诉提交',
    component: lazy(() => import(/* webpackChunkName: "evaluate-appealSubmit" */ '@/pages/Evaluate/components/EvaluateAppealSubmit/routerPage')),
    owlMetaKeys: {
      CRASH: ShopEvaluateCustomMetrics.B_APP_SHOP_EVALUATE_CRASH_NUM.KEY,
    },
  },
  {
    path: '/evaluate/appealType',
    label: '顾客评价申诉类型',
    component: lazy(() => import(/* webpackChunkName: "evaluate-appealType" */ '@/pages/Evaluate/components/EvaluateAppealType/routerPage')),
    owlMetaKeys: {
      CRASH: ShopEvaluateCustomMetrics.B_APP_SHOP_EVALUATE_CRASH_NUM.KEY,
    },
  },
  {
    path: '/bindQrcode',
    label: '自取扫码绑定',
    component: lazy(() => import(/* webpackChunkName: "bind-qrcode" */ '@/pages/BindQrcode')),
    owlMetaKeys: {
      // PV: '',
      CRASH: BindQrcodeCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/noauth',
    label: '无权限页',
    component: lazy(() => import(/* webpackChunkName: "no-auth" */ '@/pages/NoAuth')),
    owlMetaKeys: {
      // PV: '',
      CRASH: NoAuthCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/settle/guide',
    label: 'settle-guide',
    component: lazy(() => import(/* webpackChunkName: "no-auth" */ '@/pages/SettlementGuide')),
  },
  {
    path: '/settle/storeProfile',
    label: 'store-profile',
    component: lazy(() => import(/* webpackChunkName: "no-auth" */ '@/pages/StoreProfile')),
  },
  {
    path: '/settle/contractSigning',
    label: 'contract-signing',
    component: lazy(() => import(/* webpackChunkName: "no-auth" */ '@/pages/ContractSigning')),
  },
  {
    path: '/settle/completed',
    label: 'settle-completed',
    component: lazy(() => import(/* webpackChunkName: "no-auth" */ '@/pages/SettleCompleted')),
  },
  {
    path: '/financialBySelf',
    label: '自入驻结算模块',
    component: lazy(() => import(/* webpackChunkName: "financial-by-self" */ '@/pages/FinancialBySelf')),
  },
  {
    path: '/paymentConfigBySelf',
    label: '自入驻支付方式',
    component: lazy(() => import(/* webpackChunkName: "payment-config" */ '@/pages/PaymentConfigBySelf')),
  },
  {
    path: '/paymentConfig',
    label: '支付方式',
    component: lazy(() => import(/* webpackChunkName: "payment-config" */ '@/pages/PaymentConfig')),
    owlMetaKeys: {
      // PV: '',
      // CRASH: NoAuthCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/settle/settings',
    label: '营业时间设置首页',
    component: lazy(() => import(/* webpackChunkName: "settings" */ '@/pages/Settings')),
    owlMetaKeys: {
      CRASH: ShopSettingCustomMetrics.Crash.KEY,
    },
  },
  {
    path: '/delivery',
    label: '配送信息',
    component: lazy(() => import(/* webpackChunkName: "delivery" */ '@/pages/Delivery')),
  },
  {
    path: '/delivery/selfdeliverySet',
    label: '自配送设置',
    component: lazy(() => import(/* webpackChunkName: "self-delivery-set" */ '@/pages/Delivery/selfDeliveryEdit')),
  },
  {
    path: '/delivery/brandList',
    label: '品牌列表',
    component: lazy(() => import(/* webpackChunkName: "brand-list" */ '@/pages/Delivery/brandList')),
  },
  {
    path: '/delivery/selfDeliveryDetail',
    label: '配送信息详情',
    component: lazy(() => import(/* webpackChunkName: "delivery-info" */ '@/pages/Delivery/selfDeliveryDetail')),
  },
]

